/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Dtos_ParticipantLoginLog_PptLastLoginInfo } from '../models/Wealthlane_Dtos_ParticipantLoginLog_PptLastLoginInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantLoginLogSharedService {

    /**
     * @returns Wealthlane_Dtos_ParticipantLoginLog_PptLastLoginInfo OK
     * @throws ApiError
     */
    public static getApiIdentityLoginLogLastParticipant(): CancelablePromise<Wealthlane_Dtos_ParticipantLoginLog_PptLastLoginInfo> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/login-log/last/participant',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
